import IconQuestion from '@dealroadshow/uikit-icon/IconQuestion';
import Tooltip from '@dealroadshow/uikit-tooltip';
import QuestionRadioButtonField, {
  IProps as IQuestionRadioButtonProps,
} from '@evercall/call-form/ui/QuestionFields/QuestionRadioButtonField';

import { useCallFormContext } from '@evercall/call-form/ui/CallFormContext';
import getQuestionTextValue from '@evercall/call-form/ui/helpers/getQuestionTextValue';

import styles from './stepFields.module.scss';

const Question = (props: IQuestionRadioButtonProps) => {
  const {
    title,
    explanation,
  } = props;
  const { instance } = useCallFormContext();
  const renderExplanation = (content: string) => (
    <Tooltip
      containerClassName={ styles.explanationIconContainer }
      content={ content }
    >
      <IconQuestion className={ styles.explanationIcon } />
    </Tooltip>
  );

  return (
    <>
      <h3 className={ styles.questionTitle }>
        { getQuestionTextValue(title, instance) }
        { explanation && renderExplanation(getQuestionTextValue(explanation, instance)) }
      </h3>
      <div className={ styles.answersContainer }>
        <QuestionRadioButtonField { ...props } />
      </div>
    </>
  );
};

export default Question;
